import { AltBtn } from "../../../buttons"

interface Props {
  takeOverConversation: () => void
}

const AIFooter = ({ takeOverConversation }: Props) => (
  <div className="flex flex-col md:flex-row items-center justify-end gap-2 md:gap-4">
    <span className="text-sm">Katie is on</span>
    <AltBtn onClick={takeOverConversation} className="min-w-40" text="base">
      <span className="block md:hidden">Takeover from Katie</span>
      <span className="hidden md:block">Turn off Katie</span>
    </AltBtn>
  </div>
)

export default AIFooter
